import script from "./list-service-health-component.vue?vue&type=script&setup=true&lang=js"
export * from "./list-service-health-component.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__